import { Box, Button, Card, CardContent, Container, Divider, Grid, List, ListItem, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import getStockTabs from '../../lib/stock/_getStockTabsData';
import { dataConstants } from '../../src/constants';
import { getRandomStr } from '../../src/helpers';
import getPageMetaTags from '../../lib/meta/_getMetaTags';

const AboutUs = ({ tab_data }) => {
  const { asPath } = useRouter();
  const { getStockTabs } = tab_data || {}
  const { about_us, cards, founders } = getStockTabs && getStockTabs.length > 0 ? JSON.parse(getStockTabs[0]?.settings) : null
  return (
    <Container maxWidth="md" sx={{ my: 7, '& a:hover': { textDecoration: 'underline', }, '& a': { textDecoration: 'none', ml: .5, mr: .3, color: '#174c86', fontWeight: 500, fontSize: '.875rem' }, }}>
      <Typography variant="h1" classname="about-us-title" sx={{ mb: 5, textAlign: 'center', fontSize: '1.5rem', fontWeight: 500 }}>About Us</Typography>
      {about_us && about_us?.length > 0 ? about_us.map(d => (
        <Box component="div" sx={{ my: 4 }} key={`${d?.para}`}>
          {d?.text && d?.text?.length > 0 ? d?.text.map(text => (
            <Box key={getRandomStr(4)}>
              <Typography variant="p" component="div" sx={{ my: 1, fontSize: '.875rem' }}>
                {`${(text.p).replace(' - ', ' – ')}`}
              </Typography>
            </Box>
          )) : null}
        </Box>
      )) : null}
      <Box component="div" sx={{ mb: 7, }}>
        {founders && founders?.length > 0 ? founders.map(d => (
          <Box key={getRandomStr(4)}>
            <Typography variant="p" component="div" sx={{ my: .5, fontSize: '1rem', fontWeight: '600' }}>
              {d.name}
            </Typography>
            <Typography variant="p" component="div" sx={{ my: .5, fontSize: '.875rem' }}>
              {d.title}, {d?.website_link ? <a href={d?.website_link}>{d?.website_name}</a> : null}
            </Typography>
          </Box>
        )) : null}
      </Box>
      <Box component="div" sx={{
        flexDirection: { xs: 'column', sm: 'column', md: 'row' },
        textAlign: 'center', display: 'flex', justifyContent: 'space-between', mb: 4, '& a:hover': { textDecoration: 'underline', },
        '& a': { textDecoration: 'none', ml: 1, mr: .3, color: '#174c86', fontWeight: 500, fontSize: '.875rem' },
      }}>
        {cards && cards?.length > 0 ? cards.map(d => (
          <Card sx={{ my: 1.2, display: 'flex', minWidth: '270px', justifyContent: 'center', boxShadow: '0 0.5px 1px rgba(132,135,154,.2), 0 2px 3px rgba(132,135,154,.1)', background: '#fbfbfc', border: '1px solid #eae9ee', borderRadius: '5px' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <CardContent sx={{ flex: '1 0 auto' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {d?.name === "Email" ? <EmailRoundedIcon fontSize="small" sx={{ fontSize: '1.7rem', mr: 1, color: '#D44638' }} /> :
                    d?.name === "Twitter" ? <TwitterIcon fontSize="small" sx={{ fontSize: '1.7rem', mr: 1, color: '#00acee' }} /> :
                      <LinkedInIcon fontSize="small" sx={{ fontSize: '1.7rem', mr: 1, color: '#0077b5' }} />}
                  {/* <Typography component="div" variant="h6" sx={{ fontSize: '1rem' }}>
                    {d?.name}
                  </Typography> */}
                </Box>
                <Typography variant="subtitle1" component="div" sx={{ fontSize: '.875rem', my: 1 }} dangerouslySetInnerHTML={{ __html: d?.sec_text }} />
              </CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'center', pl: 1, pb: 1 }}>
                {d?.website_links && d?.website_links?.length > 0 ? d?.website_links?.map(hyper => (
                  <a href={hyper?.link}>{hyper?.link_name}</a>
                )) : null}
              </Box>
            </Box>
          </Card>
        )) : null}
      </Box >
      <Box component="div" sx={{ my: 7, py: 2 }} />
      {/* <Divider /> */}
      <Box component="div"
        sx={{
          display: 'flex', flexDirection: { xs: 'column', sm: 'column', md: 'row' }, alignItems: 'center',
          justifyContent: 'space-between', bgcolor: '#f5f6f7', px: 4, borderRadius: '5px', border: '1px solid #dcdcff'
        }}>
        <Box component="div">
          <Typography variant="body1" component="div" sx={{ fontSize: '1.2rem', mt: 7, pb: .7, color: 'text.secondary' }}>Are you ready to give it a try?</Typography>
          <Typography variant="body1" component="div" sx={{ fontSize: '1.2rem', mb: 7, color: '#174c86' }}>Let's begin and get you started.</Typography>
        </Box>
        <Box component="div">
          <Button href="/auth" size="medium" variant="contained" sx={{ textTransform: 'none', color: '#fff !important', '&:hover': { textDecoration: 'none !important', }, my: 7 }}>Create an account</Button>
        </Box>
      </Box>
      {/* <Divider /> */}
    </Container>
  )
}

export async function getStaticProps({ tabCode = "ABOUT", ticker = "" }) {

  const tab_data = (await getStockTabs(ticker, tabCode)) || [];
  const meta_tags = (await getPageMetaTags('/about', false)) || {}
  const { getMetaTags } = meta_tags || {}
  return {
    props: {
      tab_data,
      meta_tags: getMetaTags?.tags || null
    },
    revalidate: dataConstants.REVALIDATE_IN.DEFAULT_HOURS,
    // notFound: !ticker ? true : false,
  }
}

export default AboutUs
